"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exportToExcel;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _downloadjs = _interopRequireDefault(require("downloadjs"));
var _exceljs = _interopRequireDefault(require("exceljs/dist/exceljs"));
var _excelExportFormatter = _interopRequireWildcard(require("./excelExportFormatter"));
var _isNullOrUndefined = _interopRequireDefault(require("./isNullOrUndefined"));
var _exportUtil = require("./exportUtil");
var _groupedColumnHeadersHandler = require("./excelExport/groupedColumnHeadersHandler");
var _excluded = ["children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable eqeqeq */
function getValueByType(dataRow, col, rowIndex) {
  var _col$excelExport;
  var value = (0, _exportUtil.getValueByPath)(dataRow, col.dataIndex);
  if (col.excelRender && typeof col.excelRender === 'function') return col.excelRender(value, dataRow, rowIndex);

  // build test
  // formatlama excel tarafında kullanılacak ise; buradaki value değerinde bir formatlama yapılmadan excel içerisine gönderilir
  if ((col === null || col === void 0 ? void 0 : (_col$excelExport = col.excelExport) === null || _col$excelExport === void 0 ? void 0 : _col$excelExport.cellFormatter) === 'excel') return value;
  switch (col.type) {
    case _excelExportFormatter.InputTypes.currency:
      return _excelExportFormatter.default.currency(_objectSpread(_objectSpread({}, col), {}, {
        value: value
      }));
    case _excelExportFormatter.InputTypes.date:
      return _excelExportFormatter.default.date(value, col.format);
    case _excelExportFormatter.InputTypes.datetime:
      return _excelExportFormatter.default.date(value, col.format);
    case _excelExportFormatter.InputTypes.iban:
      return _excelExportFormatter.default.iban(value);
    case _excelExportFormatter.InputTypes.jsondate:
      return _excelExportFormatter.default.jsondate(value, col.format);
    case _excelExportFormatter.InputTypes.moment:
      return _excelExportFormatter.default.moment(value, col.format);
    case _excelExportFormatter.InputTypes.timestamp:
      return _excelExportFormatter.default.timestamp(value, col.format);
    case _excelExportFormatter.InputTypes.number:
      return String(value || '');
    default:
      return !!value || value === 0 ? String(value) : '';
  }
}
function getValue(valueObj, rowIndex, colIndex, mergeCellsData, headerRowCount) {
  var isRenderValueTypeObj = valueObj && (0, _typeof2.default)(valueObj) === 'object';
  var hasMergedCell = typeof mergeCellsData === 'boolean' && mergeCellsData;
  var value = isRenderValueTypeObj ? valueObj.children : valueObj;
  var mergeCellsBodyData = hasMergedCell && isRenderValueTypeObj ? handleMergeCells(valueObj.props, rowIndex, colIndex, headerRowCount) : [];
  return [value, mergeCellsBodyData];
}
function handleMergeCells(props, rowIndex, colIndex) {
  var headerRowCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  if ((0, _typeof2.default)(props) === 'object') {
    var _mergeCells = props.mergeCells;
    if ((0, _typeof2.default)(_mergeCells) === 'object') {
      var _mergeCells$rowRange = _mergeCells.rowRange,
        rowRange = _mergeCells$rowRange === void 0 ? 1 : _mergeCells$rowRange,
        _mergeCells$colRange = _mergeCells.colRange,
        colRange = _mergeCells$colRange === void 0 ? 1 : _mergeCells$colRange;
      var data = prepareMergeCells(rowIndex + headerRowCount, colIndex, rowRange, colRange);
      return [data];
    }
  }
  return [];
}
function prepareMergeCells(rowIndex, colIndex, rowRange, colRange) {
  var startRow = rowIndex + 1;
  var startColumn = colIndex + 1;
  var endRow = startRow + rowRange - 1;
  var endColumn = startColumn + colRange - 1;
  return {
    startRow: startRow,
    startColumn: startColumn,
    endRow: endRow,
    endColumn: endColumn
  };
}

/**
 * formatlamaları excel tarafına bırakmak için eklendi.
 * @param {any} col column bilgisi
 * @param {any} rowRecord row bilgisi
 * @returns {string} excel cell format,
 * Excel Format Cell altında kullanılan methodlar için eklendi,
 * custom format ataması yapılmazsa default formatlardan birini (General-Text), geriye döndürmek için undefined olarak döner.
 */
function getColumnFormat(col, rowRecord) {
  var excelExport = col.excelExport || {};
  if (excelExport.cellFormatter !== 'excel') return undefined; // default formatlamada bırakmak için eklendi

  // excel custom format kullanmak için
  if (excelExport.cellCustomFormat) {
    if (typeof excelExport.cellCustomFormat === 'function') return excelExport.cellCustomFormat(rowRecord);
    return excelExport.cellCustomFormat;
  }
  switch (col.type) {
    case _excelExportFormatter.InputTypes.currency:
      // excel tarafındaki formatlamayı kullanmak için eklendi.
      var precision = excelExport.precision || col.precision || 2;
      var currencyType = null;
      if (excelExport.currencyType) {
        currencyType = typeof (excelExport === null || excelExport === void 0 ? void 0 : excelExport.currencyType) === 'function' ? excelExport === null || excelExport === void 0 ? void 0 : excelExport.currencyType(rowRecord) : excelExport === null || excelExport === void 0 ? void 0 : excelExport.currencyType;
      } else if (col.currencyType) {
        currencyType = col.currencyType;
      } else {
        currencyType = 'TL';
      }
      currencyType = currencyType === 'YTL' ? 'TL' : currencyType.replace(/[ ]/gi, '');
      var precisionText = Math.pow(10, precision).toString().replace('1', ''); // 10 üzeri precision değeri kadar 0 oluşturulur
      var precisionSquereText = precisionText.replace(/[0]/gi, '#');
      var precisionZeroText = precisionText.replace(/[0]/gi, '0'); // eklenen 0 kadar # karakteri oluşturulur
      var currencText = " #,".concat(precisionSquereText, "0.").concat(precisionZeroText, " ").concat(currencyType, ";[Red]- #,").concat(precisionSquereText, "0.").concat(precisionZeroText, " ").concat(currencyType);
      if (!!excelExport.removeTrailingZeros || !!col.removeTrailingZeros) {
        currencText = " #,".concat(precisionSquereText, "0 ").concat(currencyType, ";[Red]- #,").concat(precisionSquereText, "0 ").concat(currencyType);
      }
      return currencText;
    case _excelExportFormatter.InputTypes.number:
      return '0.##;-0.##';
    default:
      return undefined;
  }
}

/**
 * excel DataValidation tarafında oluşturulacak olan formulas işlemi için hidden sheet oluşturulur.
 * @param {any} workBook excel workbook
 * @param {string} sheetName sheet name
 * @param {Array} data sheet data
 * @returns {any} excel worksheet
 **/
function addHiddenWorkSheet(workBook, sheetName) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (workBook.getWorksheet(sheetName)) return workBook.getWorksheet(sheetName);
  var workSheet = workBook.addWorksheet(sheetName, {
    hidden: true,
    state: 'hidden'
  });
  workSheet.addRows(data);
  return workSheet;
}
function getColumnValidation(workBook, col) {
  var _convertedData;
  var excelExport = col.excelExport || {};
  if ((0, _isNullOrUndefined.default)(excelExport.dataValidation)) return undefined;
  var dataValidation = {};
  if (typeof excelExport.dataValidation === 'function') dataValidation = excelExport.dataValidation();else dataValidation = excelExport.dataValidation;
  var hiddenSheetName = null;
  var convertedData = null;
  if (dataValidation.formulae) {
    var _dataValidation$formu, _dataValidation$formu2;
    hiddenSheetName = "".concat(col.dataIndex, "_hiddenSheet");
    convertedData = ((_dataValidation$formu = dataValidation.formulae[0]) === null || _dataValidation$formu === void 0 ? void 0 : (_dataValidation$formu2 = _dataValidation$formu.split(',')) === null || _dataValidation$formu2 === void 0 ? void 0 : _dataValidation$formu2.reduce(function (acc, item) {
      return [].concat((0, _toConsumableArray2.default)(acc), [[item]]);
    }, [])) || [];
    // worksheet varmı kontrol eder ve yoksa yeni oluşturup dataları ekler ve oluşturulan workSheet bilgisini geriye dönder.
    addHiddenWorkSheet(workBook, hiddenSheetName, convertedData);
  }
  return _objectSpread(_objectSpread({
    type: 'list',
    allowBlank: true,
    showErrorMessage: true,
    errorTitle: 'Error',
    error: "This value doesn't match the data validation restrictions defined for this cell."
  }, dataValidation), {}, {
    formulae: hiddenSheetName && dataValidation.formulae.length > 0 ? ["=".concat(hiddenSheetName, "!$A$1:$A$").concat(((_convertedData = convertedData) === null || _convertedData === void 0 ? void 0 : _convertedData.length) || 1000)] : []
  });
}
function getColumnProtection(col) {
  var _col$excelExport2;
  var columnProtect = ((_col$excelExport2 = col.excelExport) === null || _col$excelExport2 === void 0 ? void 0 : _col$excelExport2.protect) || {
    locked: false,
    hidden: false
  };
  return columnProtect;
}
function prepareColumns(columns) {
  var mappedCols = filterCols(columns);
  var filteredCols = (0, _groupedColumnHeadersHandler.getLeafColumns)(mappedCols);
  var originalCols = (0, _groupedColumnHeadersHandler.getOriginalColumns)(mappedCols);
  return {
    filteredCols: filteredCols,
    originalCols: originalCols
  };
}
function filterCols(columns) {
  return columns.filter(function (column) {
    return column && column.title && column.dataIndex;
  }).map(function (col) {
    var children = col.children,
      column = (0, _objectWithoutProperties2.default)(col, _excluded);
    // beforeDownload methodundan getColumn fonskiyonu ile yakalanıp sonradan style değiştirilebilmesi için için key ve header alanları eklendi
    column.key = column.key || column.dataIndex;
    column.header = column.title;
    var hasChildren = Array.isArray(children) && children.length > 0;
    if (hasChildren) {
      column.children = filterCols(children);
    }
    return column;
  });
}
function mapHeader(filteredCols) {
  return filteredCols.map(function (column) {
    if (column !== null && column !== void 0 && column.title && typeof column.title !== 'string' || column !== null && column !== void 0 && column.excelTitle && typeof column.excelTitle === 'string') {
      return column.excelTitle ? column.excelTitle : '';
    }
    return (column === null || column === void 0 ? void 0 : column.title) || '';
  });
}
var mapFlatHeader = function mapFlatHeader(columns) {
  return columns === null || columns === void 0 ? void 0 : columns.map(function (column) {
    return mapHeader(column);
  });
};
function prepareExcelHeaderStyle(row, filteredCols) {
  row.font = {
    bold: true,
    size: 12
  };
  row.height = 20;
  row.alignment = {
    vertical: 'middle',
    horizontal: 'center'
  };
  var headerBorderStyles = {
    top: {
      style: 'thin'
    },
    left: {
      style: 'thin'
    },
    bottom: {
      style: 'medium'
    },
    right: {
      style: 'thin'
    }
  };
  row.eachCell(function (cell, index) {
    cell.border = headerBorderStyles;
    var selectedCell = filteredCols[index - 1];
    var headerStyle = (selectedCell === null || selectedCell === void 0 ? void 0 : selectedCell.excelExport) && (selectedCell === null || selectedCell === void 0 ? void 0 : selectedCell.excelExport.headerStyle) || {};
    var preparedFillProp = prepareFillProp(headerStyle);
    var preparedFontProp = prepareFontProp(headerStyle);
    cell.fill = preparedFillProp;
    cell.font = preparedFontProp;
    return cell;
  });
}
function prepareHeaderMergeCells(filteredCols, mergeCellsData, originalCols, headerRowCount) {
  var mergeCellsHeaderData = [];
  if (headerRowCount > 1) {
    var mergedCols = (0, _groupedColumnHeadersHandler.getMergedColumns)(originalCols);
    mergeCellsHeaderData.push.apply(mergeCellsHeaderData, (0, _toConsumableArray2.default)(mergedCols));
  } else if (typeof mergeCellsData === 'boolean' && mergeCellsData) {
    filteredCols.forEach(function (col, index) {
      var _col$excelExport3, _col$excelExport3$mer;
      var range = col === null || col === void 0 ? void 0 : (_col$excelExport3 = col.excelExport) === null || _col$excelExport3 === void 0 ? void 0 : (_col$excelExport3$mer = _col$excelExport3.mergeCells) === null || _col$excelExport3$mer === void 0 ? void 0 : _col$excelExport3$mer.colRange;
      if (range) {
        var data = prepareMergeCells(0, index, 1, range);
        mergeCellsHeaderData.push(data);
      }
    });
  }
  return mergeCellsHeaderData;
}
function prepareExcelHeader(workSheet, filteredCols, mergeCellsData, originalCols, headerRowCount) {
  var flatCols = (0, _groupedColumnHeadersHandler.getFlatColumns)(originalCols, headerRowCount);
  var flatHeader = mapFlatHeader(flatCols);
  flatHeader === null || flatHeader === void 0 ? void 0 : flatHeader.forEach(function (header, index) {
    var row = workSheet.addRow(header);
    prepareExcelHeaderStyle(row, flatCols[index]);
  });
  return prepareHeaderMergeCells(filteredCols, mergeCellsData, originalCols, headerRowCount);
}
function prepareExcelBody(workSheet, filteredCols, mergeCellsData, preparedData, headerRowCount) {
  var mergeCellsBodyData = [];
  var rows = preparedData.map(function (dataRow, rowIndex) {
    var mappedValue = filteredCols.map(function (col, colIndex) {
      var valByType = getValueByType(dataRow, col, rowIndex);
      var _getValue = getValue(valByType, rowIndex, colIndex, mergeCellsData, headerRowCount),
        _getValue2 = (0, _slicedToArray2.default)(_getValue, 2),
        val = _getValue2[0],
        mergeData = _getValue2[1];
      mergeCellsBodyData = [].concat((0, _toConsumableArray2.default)(mergeCellsBodyData), (0, _toConsumableArray2.default)(mergeData));
      return val;
    });
    return mappedValue;
  });
  workSheet.addRows(rows);
  return mergeCellsBodyData;
}
function prepareColumnStylesAndLogic(workBook, ws, filteredCols, data, showExpandableColor, preparedData, headerRowCount) {
  var stepColors = ['#90bdf8', '#accdfa', '#c8defb', '#e3effd'];
  var maxStepNumber = null;
  if (showExpandableColor) {
    maxStepNumber = Math.max.apply(Math, (0, _toConsumableArray2.default)(preparedData.map(function (item) {
      return item.step;
    })));
  }
  var dataBorderStyles = {
    top: {
      style: 'thin'
    },
    left: {
      style: 'thin'
    },
    bottom: {
      style: 'thin'
    },
    right: {
      style: 'thin'
    }
  };
  ws.eachRow(function (row, rowNumber) {
    if (rowNumber <= headerRowCount) {
      // başlığı atlayalım
      return;
    }
    var rowRecord = data[rowNumber - headerRowCount - 1];
    row.eachCell(function (cell, index) {
      // index started 1,
      cell.border = dataBorderStyles;
      var selectedCell = filteredCols[index - 1];
      var contentStyle = {};

      // showExpandableColor kullanımı nested kolon başlığı kullanımı için sağlanmadı.
      // childrenlara göre rowlarda renklendirme istiyorsak bu parametreyi eklemeliyiz
      if (showExpandableColor && headerRowCount <= 1) {
        var stepCustomStyle = {
          color: '#0000',
          // only argb
          fgColor: stepColors[preparedData[rowNumber - 2].step] ? stepColors[preparedData[rowNumber - 2].step] : '#ffffff' // Colour description, an object containing an ARGB value.
        };

        // eslint-disable-next-line no-undef
        if (maxStepNumber == preparedData[rowNumber - 2].step) {
          stepCustomStyle = {};
        }
        contentStyle = stepCustomStyle;
      }

      // custom bir stil verilmiş ise burada render edilir
      if (selectedCell.excelExport && selectedCell.excelExport.contentStyle) {
        contentStyle = selectedCell.excelExport.contentStyle;
      }
      var preparedFillProp = prepareFillProp(contentStyle);
      var preparedFontProp = prepareFontProp(contentStyle);

      // tabloda basılan column alanlarının type değerlerini ayarlar
      // (Toplama işleminde excel içinden tip sectirmeden, otomatik atamak için)
      var columnFormat = getColumnFormat(selectedCell, rowRecord); // excel custom format kullanmak için

      // kolona ait data validation ayarları
      // örneğin; kolonun bir combobox gibi düşünülebilir ve bu combobox içindeki değerlerin excel içindeki bir tablodan seçilebilmesi için kullanılır.
      var columnDataValidation = getColumnValidation(workBook, selectedCell);
      cell.dataValidation = columnDataValidation;

      // Hücreye ait koruma ayarları
      var columnProtection = getColumnProtection(selectedCell);
      cell.protection = columnProtection;
      cell.font = preparedFontProp;
      cell.fill = preparedFillProp;
      cell.numFmt = columnFormat;
      if (selectedCell.type === 'currency') {
        cell.style.alignment = {
          vertical: 'middle',
          horizontal: 'right'
        };
      }
      return cell;
    });
  });
}
function colorMethodByUserLogic(ws, filteredCols, headerRowCount) {
  // beforeDownload metodu kullanımı nested kolon başlığı kullanımı için sağlanmadı.
  if (headerRowCount > 1) {
    return;
  }

  // beforeDownload methodundan getColumn fonskiyonu ile yakalanıp sonradan style değiştirilebilmesi için  columns tanımalası yapıldı.
  // aşağıdaki alan olmadan ws.getColumn(dataIndex); şeklinde bir kullanım olamaz.
  ws.columns = filteredCols;
  filteredCols.map(function (filteredCol) {
    if (filteredCol.excelExport && typeof filteredCol.excelExport.beforeDownload === 'function') {
      var dataIndex = filteredCol.dataIndex;
      var cells = ws.getColumn(dataIndex);
      filteredCol.excelExport.beforeDownload(cells, ws);
    }
  });
}
function prepareFontProp(style) {
  var _style = style || {};
  return {
    size: _style.size,
    name: _style.name,
    family: _style.family,
    bold: _style.bold,
    italic: _style.italic,
    underline: _style.underline,
    strike: _style.strike,
    outline: _style.outline,
    vertAlign: _style.vertAlign,
    color: {
      argb: _style.color && _style.color.replace('#', '')
    }
  };
}
function prepareFillProp(style) {
  var _style = style || {};
  return {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {
      argb: _style.fgColor && _style.fgColor.replace('#', '')
    },
    bgColor: {
      argb: _style.bgColor && _style.bgColor.replace('#', '')
    }
  };
}
function excelAutowidth(ws, columns) {
  for (var i = 0; i < ws.columns.length; i += 1) {
    var _columns$i, _columns$i$excelExpor;
    var col = ws.columns[i];
    if ((_columns$i = columns[i]) !== null && _columns$i !== void 0 && (_columns$i$excelExpor = _columns$i.excelExport) !== null && _columns$i$excelExpor !== void 0 && _columns$i$excelExpor.width) {
      col.width = columns[i].excelExport.width;
    } else {
      var dataMax = 0;
      for (var j = 1; j < col.values.length; j += 1) {
        var val = col.values[j];
        if (typeof col.values[j] === 'number') val = col.values[j].toString();
        var columnLength = val ? val.length : 0;
        if (columnLength > dataMax) {
          dataMax = columnLength;
        }
      }
      col.width = dataMax < 10 ? 14 : dataMax + 4;
    }
  }
}
function prepareExcelMergeCells(workSheet, mergeCellsData, mergeCellsHeader, mergeCellsBody, headerRowCount) {
  var mergedByManually = typeof mergeCellsData === 'boolean' && mergeCellsData;
  var mergedByGroupedHeader = headerRowCount > 1;
  if (mergedByManually || mergedByGroupedHeader) {
    mergeCells(workSheet, [].concat((0, _toConsumableArray2.default)(mergeCellsHeader), (0, _toConsumableArray2.default)(mergeCellsBody)));
  }
  mergeCells(workSheet, mergeCellsData);
}
function mergeCells(workSheet, mergeCellsData) {
  if (Array.isArray(mergeCellsData) && mergeCellsData.length > 0) {
    mergeCellsData.forEach(function (data) {
      var startRow = data.startRow,
        startColumn = data.startColumn,
        endRow = data.endRow,
        endColumn = data.endColumn;
      workSheet.mergeCells(startRow, startColumn, endRow, endColumn);
    });
  }
}

/**
 *
 * Note: While the protect() function returns a Promise indicating that it is async,
 * the current implementation runs on the main thread and will use approx 600ms on an average CPU. This can be adjusted by setting the spinCount,
 * which can be used to make the process either faster or more resilient.
 * @param {*} ws worksheet
 * @param {*} options
 * @param { string } options.password
 * @param { boolean } option.selectLockedCells default true, Lets the user select locked cells
 * @param { boolean } option.selectUnlockedCells	default true, Lets the user select unlocked cells
 * @param { boolean } option.formatCells default	false, Lets the user format cells
 * @param { boolean } option.formatColumns	default false, Lets the user format columns
 * @param { boolean } option.formatRows	default false, Lets the user format rows
 * @param { boolean } option.insertRows	default false, Lets the user insert rows
 * @param { boolean } option.insertColumns	default false, Lets the user insert columns
 * @param { boolean } option.insertHyperlinks	default false, Lets the user insert hyperlinks
 * @param { boolean } option.deleteRows	default false, Lets the user delete rows
 * @param { boolean } option.deleteColumns	default false, Lets the user delete columns
 * @param { boolean } option.sort	default false, Lets the user sort data
 * @param { boolean } option.autoFilter	default false, Lets the user filter data in tables
 * @param { boolean } option.pivotTables	default false, Lets the user use pivot tables
 * @param { boolean } option.spinCount	default 100000, The number of hash iterations performed when protecting or unprotecting
 */
function prepareProtectPassword(_x, _x2) {
  return _prepareProtectPassword.apply(this, arguments);
}
function _prepareProtectPassword() {
  _prepareProtectPassword = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(ws, options) {
    var _ref, _ref$password, password;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref = typeof options === 'boolean' ? {} : options, _ref$password = _ref.password, password = _ref$password === void 0 ? 'Ortak123' : _ref$password;
          _context.next = 3;
          return ws.protect(password, options);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _prepareProtectPassword.apply(this, arguments);
}
function writeBufferAndDownload(wb, fileName) {
  return wb.xlsx.writeBuffer().then(function (buf) {
    var blob = (0, _exportUtil.bufferToBlob)(buf);
    if (!blob) {
      Promise.reject('Error creating blob.');
      return false;
    }
    var result = (0, _downloadjs.default)(blob, "".concat(fileName, ".xlsx"), 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    if (result === false) {
      Promise.reject('Error downloading generated file.');
    }
    return result;
  });
}
function finalizeExcel(workBook, workSheet, data, columns, mergeCellsData, showExpandableColor) {
  var _prepareColumns = prepareColumns(columns),
    filteredCols = _prepareColumns.filteredCols,
    originalCols = _prepareColumns.originalCols;
  var preparedData = (0, _exportUtil.flatten)(data);
  var headerRowCount = (0, _groupedColumnHeadersHandler.getHeaderRowCount)(originalCols);

  // başlık ayarları, excelin ilk satırı
  var mergeCellsHeader = prepareExcelHeader(workSheet, filteredCols, mergeCellsData, originalCols, headerRowCount);

  // verinin excel satırı olarak eklenmesi
  var mergeCellsBody = prepareExcelBody(workSheet, filteredCols, mergeCellsData, preparedData, headerRowCount);

  // verilerin bulunduğu hücrelerin stilleri
  prepareColumnStylesAndLogic(workBook, workSheet, filteredCols, data, showExpandableColor, preparedData, headerRowCount);

  // sonradan belirli hücre aralıklarını manuel olarak,
  // bir logic işleme göre renklendirmek isterse
  colorMethodByUserLogic(workSheet, filteredCols, headerRowCount);

  // autowidth özelliği, sütun genişliklerini veri uzunluğuna göre ayarlar
  excelAutowidth(workSheet, filteredCols);
  prepareExcelMergeCells(workSheet, mergeCellsData, mergeCellsHeader, mergeCellsBody, headerRowCount);
}
/* Excel Helper Methods */

/**
 * ykb-ui/table componentinde gösterilen veriyi excel'e aktarır. Sadece title ve dataIndex alanları tanımlı olan column'lar dışa aktarılır.
 * @param {Object} options - Export options
 * @param {Object[]} options.columns - Excel column titles
 * @param {Object[]} options.data - Excel data
 * @param {string} options.fileName - Exported file name
 * @param {string} options.beforeDownload - Exported file name
 */
function exportToExcel(options) {
  var columns = options.columns,
    data = options.data,
    _options$fileName = options.fileName,
    fileName = _options$fileName === void 0 ? 'export' : _options$fileName,
    filename = options.filename,
    sheetName = options.sheetName,
    protect = options.protect,
    mergeCells = options.mergeCells,
    _options$showExpandab = options.showExpandableColor,
    showExpandableColor = _options$showExpandab === void 0 ? false : _options$showExpandab;
  try {
    var wb = new _exceljs.default.Workbook();
    var ws;
    if (Array.isArray(data[0])) {
      data.map(function (sheetData, i) {
        ws = Array.isArray(sheetName) ? wb.addWorksheet(sheetName[i]) : wb.addWorksheet();
        var mergeCellsData = Array.isArray(mergeCells) && Array.isArray(mergeCells[0]) ? mergeCells[i] : mergeCells;
        var finalize = Array.isArray(columns[0]) ? function () {
          return finalizeExcel(wb, ws, sheetData, columns[i], mergeCellsData, showExpandableColor);
        } : function () {
          return finalizeExcel(wb, ws, sheetData, columns, mergeCellsData, showExpandableColor);
        };
        finalize();
      });
    } else {
      ws = sheetName ? wb.addWorksheet(sheetName) : wb.addWorksheet();
      finalizeExcel(wb, ws, data, columns, mergeCells, showExpandableColor);
    }

    // protect olan Excel için şifre belirleme işlemi
    // hücre içlerinde kullanılan lock ve unlock işlemlerinin kullanılabilir olması için excel tarafında bu alan must.
    protect && prepareProtectPassword(ws, protect);
  } catch (err) {
    return Promise.reject(err);
  }
  var excelFileName = filename || fileName;
  return writeBufferAndDownload(wb, excelFileName);
}